import { jsx as _jsx } from "react/jsx-runtime";
import { Header_WithOptionMenu } from '@app/styles/frontend/ui-manager/headers/Header_WithOptionMenu/index';
import { PathwayStateTypeLabelMap } from '@app/pathway-shared';
export const Header_PathwayState = (props) => {
    let subtitle = 'State';
    if (props.pathwayState.item.type)
        subtitle = `${PathwayStateTypeLabelMap[props.pathwayState.item.type]} State${props.subTitle ? `, ${props.subTitle}` : ''}`;
    return _jsx(Header_WithOptionMenu, { title: props.headerText ?? props.pathwayState.item.name, subtitle: subtitle, className: 'small-title', onTitleClick: props.clickableTitle ? () => props.functions.selectPathwayState(props.pathwayState) : undefined, menuActions: props.actions });
};
//# sourceMappingURL=Header_PathwayState.js.map